import {useContext} from 'react';
import {SkeletonContext} from 'modules/skeleton/components/SkeletonWrapper';

export const useIsSkeleton = (): boolean => {
    return useContext(SkeletonContext);
};
